import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import About from "./pages/About";
import Notice from "./pages/Notice";
import NoticeDetail from "./pages/NoticeDetail";
import AnimalList from "./pages/AnimalList";
import Contact from "./pages/Contact";
import Order from "./pages/Order";
import Auth from "./pages/Auth";
import Resources from "./pages/Resources";
import ResourceViewer from "./pages/ResourceViewer";
import NotFound from "./pages/NotFound";

import useMobileViewport from "@/hooks/useMobileViewport";
import ViewportSync from "@/components/ViewportSync";

const queryClient = new QueryClient();

const App = () => {
  useMobileViewport()
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ViewportSync />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/about" element={<About />} />
            <Route path="/notice" element={<Notice />} />
            <Route path="/notice/:id" element={<NoticeDetail />} />
            <Route path="/animal-list" element={<AnimalList />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/order" element={<Order />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/view-resource" element={<ResourceViewer />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  )
};

export default App;
